import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectionRange } from '@progress/kendo-angular-dateinputs';
import { contractModificationsWizardSteps } from 'src/app/models/wizard-enum';

@Component({
  selector: 'contract-modification-postpone-period',
  templateUrl: './postpone-period.component.html',
  styleUrls: ['./postpone-period.component.scss'],
  standalone: false,
})
export class PostponePeriodComponent {
  wizardStepsEnum = contractModificationsWizardSteps;

  @Input() public postponedPeriodRange: SelectionRange;
  @Output() postponedPeriodRangeChanged: EventEmitter<{ start: Date; end: Date }> = new EventEmitter();

  @Input() nextStepHandler: any;

  onSelectionRangeChange(newRange: SelectionRange) {
    this.postponedPeriodRange = newRange;
  }

  handleNextStep(step: contractModificationsWizardSteps) {
    this.postponedPeriodRangeChanged.emit(this.postponedPeriodRange);
    this.nextStepHandler(step);
  }

  diasblePastMonths = (date: Date) => {
    let refDate = new Date();
    return (
      date.getFullYear() < refDate.getFullYear() ||
      (date.getFullYear() === refDate.getFullYear() && date.getMonth() < refDate.getMonth())
    );
  };
}
